import React, { useEffect, useState } from "react";
import { Link, useLocation, matchPath, useNavigate } from "react-router-dom";
import Logout from "./Logout";
import { useAuth } from "../context/AuthContext";
import lg from "../assets/amawta_lp.png";

import {
  Typography,
  AppBar,
  Toolbar,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  useMediaQuery,
  Dialog,
  DialogContent,
  Divider,
  TextField,
  Alert as MuiAlert,
  InputAdornment,
  CircularProgress,
  Menu,
  MenuItem,
} from "@mui/material";


import Slide from "@mui/material/Slide";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Collapse from "@mui/material/Collapse";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import LockResetOutlinedIcon from "@mui/icons-material/LockResetOutlined";
import "./NavBar.css";
import {
  getHomeData,
  HERRAMIENTAS_DOCENTE_HABILITADAS,
} from "../pages/home/config/homeData"
import LoginService from "../services/LoginService";

const TransitionUp = React.forwardRef(function TransitionUp(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const NavBar = () => {

  const capitalize = (text = "") =>
    text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  const [openUser, setOpenUser] = useState(false);
  const [openUserModal, setOpenUserModal] = useState(false);
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });
  const [passwordFeedback, setPasswordFeedback] = useState({ type: "", message: "" });
  const [changingPassword, setChangingPassword] = useState(false);
  const [validatingCurrentPassword, setValidatingCurrentPassword] = useState(false);
  const [currentPasswordValidated, setCurrentPasswordValidated] = useState(false);
  const [showPasswords, setShowPasswords] = useState({
    current_password: false,
    new_password: false,
    confirm_password: false,
  });

  const { user, switchContext, loading } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const isPathActive = (pattern) =>
    Boolean(matchPath({ path: pattern, end: false }, pathname));

  const isItemActive = (path) => isPathActive(`${path}/*`) || isPathActive(path);

  const theme = useTheme();
  const isAdmin = user?.rol?.nombre === "ADMIN";
  const isMobile = useMediaQuery(
    isAdmin ? "(max-width:1550px)" : "(max-width:1050px)"
  );
  const [openDrawer, setOpenDrawer] = useState(false);

  const rolRaw = (user?.rol?.nombre || "Sin rol").toString();

  const nombreUsuario = user?.usuario?.nombres
    ? user.usuario.nombres.trim().split(" ")[0]
    : "Sin nombre";
  // ${user.usuario.apellidos}
  const toggleDrawer = (open) => () => setOpenDrawer(open);

  // El selector se conserva para una futura reactivación, pero permanece oculto.
  const [anchorIA, setAnchorIA] = useState(null);
  const openIA = Boolean(anchorIA);
  const [menuWidthIA, setMenuWidthIA] = useState(0);
  const [openIA_Mobile, setOpenIA_Mobile] = useState(false);

  const upXl = useMediaQuery(theme.breakpoints.up("xl"));     // >= xl
  const betweenMdLg = useMediaQuery(theme.breakpoints.between("sm", "lg")); // md <= w < lg


  const homeData = getHomeData(rolRaw.toLowerCase());

  const sesionesAprendizaje = homeData
    .filter(item => item.eyebrow === "Módulo planificador de sesiones")
    .map(item => ({
      text: item.title,
      path: item.route
    }));

  const herramientasDocente = homeData
    .filter(item => item.eyebrow === "Módulo Herramientas al docente")
    .map(item => ({
      text: item.title,
      path: item.route
    }));

  const saludo = upXl
    ? `Te damos la bienvenida, ${nombreUsuario}`
    : betweenMdLg
      ? ""
      : `Hola, ${nombreUsuario}`;

  const sxNavButton = (active = false) => ({
    fontFamily: "Montserrat-Medium",
    fontWeight: 500,
    letterSpacing: { xs: "0.02em", md: "0.04em" },
    textTransform: "none",
    color: "#fff",
    borderRadius: "12px",
    px: { xs: 1.25, sm: 1.5, md: 2 },
    py: { xs: 0.6, sm: 0.75 },
    whiteSpace: "nowrap",
    minWidth: { md: 200, lg: 260 },
    justifyContent: "space-between",
    border: active ? "1px solid var(--primary)" : "1px solid rgba(255,255,255,0.25)",
    backgroundColor: active ? "rgba(255,255,255,0.10)" : "rgba(255,255,255,0.03)",
    boxShadow: active ? "0 0 0 2px rgba(0,199,219,0.25) inset" : "none",
    transition:
      "background 0.25s ease, border 0.25s ease, transform 0.2s ease, box-shadow 0.25s ease",
    "&:hover": {
      borderColor: "var(--primary)",
      transform: "translateY(-1px)",
      backgroundColor: "rgba(255,255,255,0.05)",
    },
    "&:focus-visible": {
      outline: "2px solid rgba(0,199,219,0.6)",
      outlineOffset: "3px",
    },
    "& .MuiButton-endIcon svg": { color: "#fff" },
  });

  const sxMenuPaper = (w) => ({
    width: w || undefined,
    mt: 0.5,
    border: "1px solid rgba(255,255,255,0.10)",
    borderRadius: 2,
    overflow: "hidden",
    backgroundColor: "#17339a",
    boxShadow: "0 10px 24px rgba(0,0,0,0.22)",
  });

  const sxMenuItem = {
    fontFamily: "Montserrat-Medium",
    fontSize: { xs: "0.72rem", sm: "0.8rem", md: "0.85rem" },
    lineHeight: 1.4,
    letterSpacing: "0.04em",
    fontWeight: 500,
    backgroundColor: "#17339a",
    color: "#fff",
    px: 2,
    py: { xs: 0.75, md: 1 },
    borderLeft: "3px solid transparent",
    borderBottom: "1px solid rgba(255,255,255,0.08)",
    whiteSpace: "normal",
    wordBreak: "break-word",
    transition: "background-color 0.2s ease, border-left 0.2s ease, box-shadow 0.2s ease",
    "&:hover, &.Mui-focusVisible": {
      backgroundColor: "#1f3fb3",
      borderLeft: "3px solid var(--primary)",
      boxShadow: "inset 0 0 10px rgba(255,255,255,0.12)",
    },
    "&:last-of-type": {
      borderBottom: "none",
    },
  };

  const safeCap = (txt = "") => capitalize(String(txt || "").trim());

  const nombresRaw = (user?.usuario?.nombres || "").trim();
  const apellidosRaw = (user?.usuario?.apellidos || "").trim();

  const primerNombre = nombresRaw.split(/\s+/)[0] || "";
  const primerApellido = apellidosRaw.split(/\s+/)[0] || "";

  const nombreMostrado = primerApellido
    ? `${safeCap(primerNombre)} ${safeCap(primerApellido)}`
    : safeCap(nombresRaw);

  const activeIA = herramientasDocente.some((item) => isItemActive(item.path));
  const contextosAgrupados = Array.isArray(user?.contextos_agrupados)
    ? user.contextos_agrupados
    : [];
  const shouldShowInstitutionList = !isAdmin && contextosAgrupados.length > 0;

  const getFriendlyRoleName = (roleName = "") => {
    const normalized = String(roleName || "").toUpperCase();
    if (normalized === "DIRECTOR") return "Docente Admin";
    if (normalized === "PROFESOR") return "Docente";
    return capitalize(normalized);
  };

  useEffect(() => {
    if (!openPasswordModal) {
      setPasswordForm({
        current_password: "",
        new_password: "",
        confirm_password: "",
      });
      setPasswordFeedback({ type: "", message: "" });
      setChangingPassword(false);
      setValidatingCurrentPassword(false);
      setCurrentPasswordValidated(false);
      setShowPasswords({
        current_password: false,
        new_password: false,
        confirm_password: false,
      });
    }
  }, [openPasswordModal]);

  const handlePasswordFieldChange = (event) => {
    const { name, value } = event.target;
    setPasswordForm((prev) => {
      if (name === "current_password") {
        return {
          ...prev,
          current_password: value,
          ...(currentPasswordValidated
            ? { new_password: "", confirm_password: "" }
            : {}),
        };
      }

      return { ...prev, [name]: value };
    });

    if (name === "current_password") {
      setCurrentPasswordValidated(false);
    }

    setPasswordFeedback({ type: "", message: "" });
  };

  const togglePasswordVisibility = (fieldName) => {
    setShowPasswords((prev) => ({
      ...prev,
      [fieldName]: !prev[fieldName],
    }));
  };

  const closeUserModal = () => {
    setOpenUserModal(false);
  };

  const closePasswordModal = () => {
    setOpenPasswordModal(false);
  };

  const openPasswordChangeModal = () => {
    setOpenPasswordModal(true);
  };

  const handleValidateCurrentPassword = async () => {
    const { current_password } = passwordForm;

    if (!current_password) {
      setPasswordFeedback({
        type: "error",
        message: "Ingresa tu contraseña actual para validarla.",
      });
      return;
    }

    setValidatingCurrentPassword(true);
    setPasswordFeedback({ type: "", message: "" });

    try {
      const response = await LoginService.validateCurrentPassword({ current_password });
      setCurrentPasswordValidated(true);
      setPasswordFeedback({
        type: "success",
        message:
          response?.data?.message ||
          "Contraseña actual validada. Ya puedes registrar una nueva.",
      });
    } catch (error) {
      setCurrentPasswordValidated(false);
      setPasswordFeedback({
        type: "error",
        message:
          error?.response?.data?.detail ||
          "No se pudo validar la contraseña actual.",
      });
    } finally {
      setValidatingCurrentPassword(false);
    }
  };

  const handleSwitchProfileContext = async (institucionId) => {
    const result = await switchContext(institucionId);
    if (!result?.authenticated) {
      setPasswordFeedback({
        type: "error",
        message: "No se pudo cambiar el contexto institucional.",
      });
    }
  };

  const handleChangePassword = async () => {
    const { current_password, new_password, confirm_password } = passwordForm;

    if (!currentPasswordValidated) {
      setPasswordFeedback({
        type: "error",
        message: "Primero valida tu contraseña actual.",
      });
      return;
    }

    if (!current_password || !new_password || !confirm_password) {
      setPasswordFeedback({
        type: "error",
        message: "Completa los tres campos para actualizar la contraseña.",
      });
      return;
    }

    if (new_password !== confirm_password) {
      setPasswordFeedback({
        type: "error",
        message: "La nueva contraseña y la confirmación no coinciden.",
      });
      return;
    }

    if (current_password === new_password) {
      setPasswordFeedback({
        type: "error",
        message: "La nueva contraseña debe ser diferente a la actual.",
      });
      return;
    }

    setChangingPassword(true);
    setPasswordFeedback({ type: "", message: "" });

    try {
      const response = await LoginService.changePassword(passwordForm);
      setPasswordFeedback({
        type: "success",
        message: response?.data?.message || "Contraseña actualizada correctamente.",
      });
      setPasswordForm({
        current_password: "",
        new_password: "",
        confirm_password: "",
      });
      setCurrentPasswordValidated(false);
    } catch (error) {
      setPasswordFeedback({
        type: "error",
        message:
          error?.response?.data?.detail ||
          "No se pudo actualizar la contraseña. Inténtalo de nuevo.",
      });
    } finally {
      setChangingPassword(false);
    }
  };

  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          backgroundColor: "#031a7f",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.25)",
          zIndex: (theme) => theme.zIndex.appBar,
        }}
        className="navbar-root"
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* LOGO */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Link to="/" style={{ textDecoration: "none" }}>
              <Box
                sx={{
                  width: { xs: 100, md: 150 },
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src={lg}
                  alt="Logo"
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                    objectFit: "contain",
                  }}
                />
              </Box>
            </Link>

            {/* MENÚ DESKTOP */}
            {!isMobile && (() => {

              return (
                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                  {sesionesAprendizaje.map((item) => (
                    <Button
                      key={item.text}
                      color="inherit"
                      onClick={() => navigate(item.path)}
                      sx={{
                        ...sxNavButton(isItemActive(item.path)),
                        minWidth: "auto",
                        justifyContent: "center",
                      }}
                    >
                      {item.text}
                    </Button>
                  ))}

                  {HERRAMIENTAS_DOCENTE_HABILITADAS && (
                    <Button
                      color="inherit"
                      endIcon={<KeyboardArrowDownIcon />}
                      onClick={(e) => {
                        const target = e.currentTarget;
                        const abrir = !anchorIA;
                        setAnchorIA(abrir ? target : null);
                        if (abrir) setMenuWidthIA(target.offsetWidth);
                      }}
                      sx={sxNavButton(activeIA)}
                    >
                      Herramientas al docente
                    </Button>
                  )}

                  {isAdmin && (
                    <>
                      <Button
                        color="inherit"
                        onClick={() => navigate("/admin/gestor-usuarios")}
                        sx={{
                          ...sxNavButton(isItemActive("/admin/gestor-usuarios")),
                          minWidth: "150px",
                        }}
                      >
                        Gestor de usuarios
                      </Button>
                    </>
                  )}

                  {HERRAMIENTAS_DOCENTE_HABILITADAS && (
                    <Menu
                      anchorEl={anchorIA}
                      open={openIA}
                      onClose={() => setAnchorIA(null)}
                      disableScrollLock
                      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                      transformOrigin={{ vertical: "top", horizontal: "left" }}
                      slotProps={{ paper: { sx: sxMenuPaper(menuWidthIA) } }}
                      MenuListProps={{ sx: { py: 0 } }}
                    >
                      {herramientasDocente.map((item) => (
                        <MenuItem
                          key={item.text}
                          onClick={() => { setAnchorIA(null); navigate(item.path); }}
                          sx={{
                            ...sxMenuItem,
                            borderLeft: isItemActive(item.path) ? "3px solid var(--primary)" : "3px solid transparent",
                            backgroundColor: isItemActive(item.path) ? "#1f3fb3" : "#17339a",
                            fontWeight: isItemActive(item.path) ? 700 : 500,
                          }}
                        >
                          {item.text}
                        </MenuItem>
                      ))}
                    </Menu>
                  )}

                </Box>
              );
            })()}
          </Box>

          {/* USUARIO / LOGOUT */}
          {!isMobile ? (
            <Box
              sx={{
                display: "flex",
                alignItems: { xs: "stretch", sm: "center" },
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 1, sm: 2 },
                width: { xs: "100%", sm: "auto" },
              }}
            >
              {/* PERFIL USUARIO */}
              <Box
                onMouseEnter={() => setOpenUser(true)}
                onMouseLeave={() => setOpenUser(false)}
                onClick={() => setOpenUserModal(true)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: { xs: "space-between", sm: "flex-start" },
                  gap: 0.8,
                  px: { xs: 1.25, sm: 1 },
                  py: { xs: 1, sm: 0.5 },
                  borderRadius: 2,
                  cursor: "pointer",
                  width: { xs: "100%", sm: "auto" },
                  backgroundColor: openUser ? "rgba(255,255,255,0.15)" : "transparent",
                  transition: "background-color 0.2s ease",
                  userSelect: "none",
                }}
              >
                <AccountCircleIcon
                  sx={{
                    fontSize: { xs: 28, sm: 24 },
                    opacity: 0.95,
                    color: "#ffffff",
                    flexShrink: 0,
                  }}
                />

                <Typography
                  sx={{
                    fontFamily: "Montserrat-Medium",
                    fontSize: "0.75rem",
                    letterSpacing: "0.04em",
                    opacity: 0.9,
                    color: "#ffffff",
                    whiteSpace: "nowrap",
                  }}
                >
                  {saludo}
                </Typography>
              </Box>

              {/* LOGOUT */}
              <Box
                sx={{
                  width: { xs: "100%", sm: "auto" },
                  display: "flex",
                  justifyContent: { xs: "stretch", sm: "flex-start" },
                }}
              >
                <Box
                  sx={{
                    width: { xs: "100%", sm: "auto" },
                    "& button": {
                      width: { xs: "100%", sm: "auto" }, // si Logout renderiza un Button
                    },
                  }}
                >
                  <Logout />
                </Box>
              </Box>
            </Box>
          ) : (
            <IconButton color="inherit" onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>
          )}

        </Toolbar>
      </AppBar>

      {/* DRAWER MÓVIL */}
      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={toggleDrawer(false)}
        slotProps={{
          paper: {
            sx: {
              width: "min(400px, 90vw)",
              maxWidth: "min(400px, 90vw)",
              height: "100%",
              border: "none",
              backgroundColor: "#F7F9FC",
              boxShadow: "0 18px 40px rgba(2,6,23,0.18)",
            },
          },
        }}
      >
        {(() => {
          const sxSectionCard = {
            mx: 2,
            mt: 2,
            borderRadius: 2,
            backgroundColor: "#fff",
            border: "1px solid rgba(15,23,42,0.08)",
            overflow: "hidden",
          };

          const sxChildBtn = {
            px: 2,
            py: 0.9,
            borderTop: "1px solid rgba(15,23,42,0.06)",
            "&:hover": { backgroundColor: "rgba(3,26,127,0.05)" },
          };

          const sxChildText = {
            fontFamily: "Montserrat-Regular",
            fontSize: "0.9rem",
            color: "#0F172A",
          };

          return (
            <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
              {/* ===== HEADER ===== */}
              <Box
                sx={{
                  px: 2,
                  py: 1.1,
                  backgroundColor: "#031A7F",
                  color: "#fff",
                  borderBottom: "1px solid rgba(255,255,255,0.14)",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                  <Avatar
                    sx={{
                      bgcolor: "rgba(255,255,255,0.18)",
                      color: "#fff",
                      width: 44,
                      height: 44,
                      fontFamily: "Montserrat-Bold",
                    }}
                  >
                    {user?.usuario?.nombres?.charAt(0)}
                    {user?.usuario?.apellidos?.charAt(0)}
                  </Avatar>

                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      sx={{
                        fontFamily: "Montserrat-Bold",
                        fontSize: "1rem",
                        lineHeight: 1.2,
                      }}
                    >
                      {nombreMostrado}
                    </Typography>

                    <Typography
                      sx={{
                        mt: 0.25,
                        fontFamily: "Montserrat-Regular",
                        fontSize: "0.8rem",
                        opacity: 0.9,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: 240,
                      }}
                    >
                      {
                        user?.rol?.nombre === "DIRECTOR"
                          ? "Docente Admin"
                          : (user?.rol?.nombre === "PROFESOR" ? "Docente" : capitalize(user?.rol?.nombre))
                      }
                      {!isAdmin && ` • ${user?.institucion?.nombre || "Institución"}`}
                    </Typography>
                  </Box>
                </Box>

                {/* CTA */}
                <Box sx={{ display: "flex", gap: 1, mt: 1.5 }}>

                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={() => {
                      setOpenDrawer(false);
                      setOpenUserModal(true);
                    }}
                    sx={{
                      borderRadius: 2,
                      textTransform: "none",
                      fontFamily: "Montserrat-Medium",
                      borderColor: "rgba(255,255,255,0.45)",
                      color: "#fff",
                      "&:hover": { borderColor: "rgba(255,255,255,0.75)" },
                    }}
                  >
                    Perfil
                  </Button>
                </Box>
              </Box>

              {/* ===== CONTENIDO ===== */}
              <Box sx={{ flex: 1, overflowY: "auto", pb: 2 }}>
                {/* === Sesiones === */}
                <Box sx={sxSectionCard}>
                  <List disablePadding>
                    {sesionesAprendizaje.map((item) => (
                      <ListItem key={item.text} disablePadding>
                        <ListItemButton
                          component={Link}
                          to={item.path}
                          onClick={toggleDrawer(false)}
                          sx={{
                            ...sxChildBtn,
                            minWidth: 0,
                            backgroundColor: isItemActive(item.path) ? "rgba(3,26,127,0.06)" : "transparent",
                            borderLeft: isItemActive(item.path) ? "3px solid #031A7F" : "3px solid transparent",
                          }}
                        >
                          <ListItemText
                            primary={item.text}
                            primaryTypographyProps={{
                              ...sxChildText,
                              fontWeight: isItemActive(item.path) ? 700 : 400,
                            }}
                            sx={{ minWidth: 0 }}
                          />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </List>
                </Box>

                {HERRAMIENTAS_DOCENTE_HABILITADAS && (
                  <Box sx={sxSectionCard}>
                    <List disablePadding>
                      <ListItem disablePadding>
                        <ListItemButton
                          onClick={() => setOpenIA_Mobile(!openIA_Mobile)}
                          sx={{
                            px: 2,
                            py: 1.1,
                            justifyContent: "space-between",
                            backgroundColor: openIA_Mobile || activeIA
                              ? "rgba(3,26,127,0.06)"
                              : "transparent",
                            "&:hover": { backgroundColor: "rgba(3,26,127,0.06)" },
                          }}
                        >
                          <ListItemText
                            primary="Herramientas al docente"
                            primaryTypographyProps={{
                              fontFamily: "Montserrat-Medium",
                              fontSize: "0.95rem",
                              color: "#0F172A",
                            }}
                          />
                          <ExpandMoreIcon
                            sx={{
                              color: "#031A7F",
                              transform: openIA_Mobile ? "rotate(180deg)" : "rotate(0deg)",
                              transition: "transform 0.2s ease",
                            }}
                          />
                        </ListItemButton>
                      </ListItem>

                      <Collapse in={openIA_Mobile} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                          {herramientasDocente.map((item) => (
                            <ListItem key={item.text} disablePadding>
                              <ListItemButton
                                component={Link}
                                to={item.path}
                                onClick={toggleDrawer(false)}
                                sx={{
                                  ...sxChildBtn,
                                  minWidth: 0,
                                  backgroundColor: isItemActive(item.path) ? "rgba(3,26,127,0.06)" : "transparent",
                                  borderLeft: isItemActive(item.path) ? "3px solid #031A7F" : "3px solid transparent",
                                }}
                              >
                                <ListItemText
                                  primary={item.text}
                                  sx={{ minWidth: 0 }}
                                  primaryTypographyProps={{
                                    ...sxChildText,
                                    fontWeight: isItemActive(item.path) ? 700 : 400,
                                  }}
                                />
                              </ListItemButton>
                            </ListItem>
                          ))}
                        </List>
                      </Collapse>
                    </List>
                  </Box>
                )}

                {isAdmin && (
                  <Box sx={sxSectionCard}>
                    <List disablePadding>
                      <ListItem disablePadding>
                        <ListItemButton
                          component={Link}
                          to="/admin/gestor-usuarios"
                          onClick={toggleDrawer(false)}
                          sx={{
                            px: 2,
                            py: 1.1,
                            justifyContent: "flex-start",
                            backgroundColor: isItemActive("/admin/gestor-usuarios")
                              ? "rgba(3,26,127,0.06)"
                              : "transparent",
                            borderLeft: isItemActive("/admin/gestor-usuarios")
                              ? "3px solid #031A7F"
                              : "3px solid transparent",
                            "&:hover": {
                              backgroundColor: "rgba(3,26,127,0.06)",
                            },
                          }}
                        >
                          <ListItemText
                            primary="Gestor de usuarios"
                            primaryTypographyProps={{
                              fontFamily: "Montserrat-Medium",
                              fontSize: "0.95rem",
                              color: "#0F172A",
                              fontWeight: isItemActive("/admin/gestor-usuarios")
                                ? 700
                                : 500,
                            }}
                          />
                        </ListItemButton>
                      </ListItem>
                    </List>
                  </Box>
                )}
              </Box>

              {/* ===== FOOTER ===== */}
              <Box
                sx={{
                  px: 2.25,
                  py: 1.75,
                  borderTop: "1px solid rgba(15,23,42,0.08)",
                  // backgroundColor: "#F7F9FC",
                }}
              >
                <Box
                  sx={{
                    "& .MuiButton-root": {
                      width: "100%",
                      borderRadius: 2,
                      textTransform: "none",
                      fontFamily: "Montserrat-Medium",
                      fontSize: "0.9rem",
                      color: "#031A7F !important",
                      border: "1px solid rgba(3,26,127,0.25)",
                      backgroundColor: "#FFFFFF",
                      "&:hover": { backgroundColor: "rgba(3,26,127,0.06)" },
                    },
                    "& .MuiIconButton-root": {
                      width: "100%",
                      borderRadius: 2,
                      justifyContent: "center",
                      color: "#031A7F !important",
                      border: "1px solid rgba(3,26,127,0.25)",
                      backgroundColor: "#FFFFFF",
                      "&:hover": { backgroundColor: "rgba(3,26,127,0.06)" },
                    },
                    "& a": {
                      display: "block",
                      width: "100%",
                      textAlign: "center",
                      padding: "10px 12px",
                      borderRadius: 12,
                      textDecoration: "none",
                      fontFamily: "Montserrat-Medium",
                      fontSize: "0.9rem",
                      color: "#031A7F !important",
                      border: "1px solid rgba(3,26,127,0.25)",
                      backgroundColor: "#FFFFFF",
                    },
                    "& a:hover": { backgroundColor: "rgba(3,26,127,0.06)" },
                  }}
                >
                  <Logout />
                </Box>

                <Typography
                  sx={{
                    mt: 1,
                    fontFamily: "Montserrat-Regular",
                    fontSize: "0.72rem",
                    color: "#64748b",
                    textAlign: "center",
                  }}
                >
                  Colaboraccion SAC • 2026
                </Typography>
              </Box>
            </Box>
          );
        })()}
      </Drawer>

      <Dialog
        open={openUserModal}
        onClose={closeUserModal}
        maxWidth="sm"
        fullWidth
        TransitionComponent={TransitionUp}
      >
        {/* HEADER */}
        <Box
          sx={{
            backgroundColor: "#031A7F",
            color: "#ffffff",
            px: 3,
            py: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            {/* AVATAR */}
            <Avatar
              sx={{
                bgcolor: "rgba(255,255,255,0.15)",
                color: "#fff",
                width: 48,
                height: 48,
                fontFamily: "Montserrat-Bold",
                fontSize: "1.1rem",
              }}
            >
              {user?.usuario?.nombres?.charAt(0)}
              {user?.usuario?.apellidos?.charAt(0)}
            </Avatar>

            <Box>
              <Typography
                sx={{
                  fontFamily: "Montserrat-Bold",
                  fontSize: "1.1rem",
                  letterSpacing: "0.04em",
                }}
              >
                Perfil de {nombreMostrado}
              </Typography>

              <Chip
                label={
                  user?.rol?.nombre === "DIRECTOR"
                    ? "Docente Admin"
                    : (user?.rol?.nombre === "PROFESOR" ? "Docente" : capitalize(user?.rol?.nombre))
                }
                size="small"
                sx={{
                  mt: 0.5,
                  fontFamily: "Montserrat-Medium",
                  backgroundColor: "rgba(255,255,255,0.2)",
                  color: "#fff",
                  letterSpacing: "0.04em",
                }}
              />
            </Box>
          </Box>

          <IconButton
            onClick={closeUserModal}
            sx={{ color: "#ffffff" }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* CONTENIDO */}
        <DialogContent
          sx={{
            px: 3,
            py: 3,
            display: "flex",
            flexDirection: "column",
            gap: 2.5,
          }}
        >
          {/* ===== USUARIO ===== */}
          <Box>
            <Typography
              sx={{
                fontFamily: "Montserrat-Bold",
                fontSize: "1rem",
                color: "#031A7F",
                mb: 1,
              }}
            >
              Usuario
            </Typography>

            <Typography sx={{ fontFamily: "Montserrat-Regular", fontSize: "0.9rem" }}>
              <strong>Nombres:</strong> {user?.usuario?.nombres}
            </Typography>
            <Typography sx={{ fontFamily: "Montserrat-Regular", fontSize: "0.9rem" }}>
              <strong>Apellidos:</strong> {user?.usuario?.apellidos}
            </Typography>
            <Typography sx={{ fontFamily: "Montserrat-Regular", fontSize: "0.9rem" }}>
              <strong>DNI:</strong> {user?.usuario?.id}
            </Typography>
          </Box>

          {!isAdmin && !shouldShowInstitutionList && (
            <>
              <Divider />

              {/* ===== INSTITUCIÓN ===== */}
              <Box>
                <Typography
                  sx={{
                    fontFamily: "Montserrat-Bold",
                    fontSize: "1rem",
                    color: "#031A7F",
                    mb: 1,
                  }}
                >
                  Institución Educativa
                </Typography>

                <Typography sx={{ fontFamily: "Montserrat-Regular", fontSize: "0.9rem" }}>
                  <strong>Nombre:</strong> {user?.institucion?.nombre}
                </Typography>
                <Typography sx={{ fontFamily: "Montserrat-Regular", fontSize: "0.9rem" }}>
                  <strong>Código Modular:</strong> {user?.institucion?.id}
                </Typography>
              </Box>

              <Divider />

              {/* ===== UBICACIÓN (GRID 2 COLUMNAS) ===== */}
              <Box>
                <Typography
                  sx={{
                    fontFamily: "Montserrat-Bold",
                    fontSize: "1rem",
                    color: "#031A7F",
                    mb: 1,
                  }}
                >
                  Ubicación
                </Typography>

                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <Typography sx={{ fontFamily: "Montserrat-Regular", fontSize: "0.9rem" }}>
                      <strong>Región:</strong> {user?.ubicacion?.region}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography sx={{ fontFamily: "Montserrat-Regular", fontSize: "0.9rem" }}>
                      <strong>Provincia:</strong> {user?.ubicacion?.provincia}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography sx={{ fontFamily: "Montserrat-Regular", fontSize: "0.9rem" }}>
                      <strong>Distrito:</strong> {user?.ubicacion?.distrito}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography sx={{ fontFamily: "Montserrat-Regular", fontSize: "0.9rem" }}>
                      <strong>Ubigeo:</strong> {user?.ubicacion?.ubigeo}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </>
          )}

          {shouldShowInstitutionList && (
            <>
              <Divider />

              <Box>
                <Typography
                  sx={{
                    fontFamily: "Montserrat-Bold",
                    fontSize: "1rem",
                    color: "#031A7F",
                    mb: 1.25,
                  }}
                >
                  Mis instituciones
                </Typography>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                  {contextosAgrupados.map((grupo) => (
                    <Box
                      key={grupo.grupo_id}
                      sx={{
                        border: "1px solid rgba(15,23,42,0.10)",
                        borderRadius: 2,
                        p: 2,
                        backgroundColor: grupo.activo ? "rgba(3,26,127,0.04)" : "#fff",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          gap: 1.5,
                          mb: 1,
                        }}
                      >
                        <Box sx={{ minWidth: 0 }}>
                          <Typography
                            sx={{
                              fontFamily: "Montserrat-Bold",
                              fontSize: "0.96rem",
                              color: "#0F172A",
                            }}
                          >
                            {grupo.nombre_ie}
                          </Typography>
                          {grupo.codigo_institucion && (
                            <Typography
                              sx={{
                                mt: 0.35,
                                fontFamily: "Montserrat-Regular",
                                fontSize: "0.82rem",
                                color: "#64748b",
                              }}
                            >
                              Código de institución: {grupo.codigo_institucion}
                            </Typography>
                          )}
                          {grupo.region && (
                            <Typography
                              sx={{
                                fontFamily: "Montserrat-Regular",
                                fontSize: "0.82rem",
                                color: "#64748b",
                              }}
                            >
                              Región: {grupo.region}
                            </Typography>
                          )}
                        </Box>

                        {grupo.activo && (
                          <Chip
                            label="Activa"
                            size="small"
                            sx={{
                              fontFamily: "Montserrat-Medium",
                              backgroundColor: "rgba(3,26,127,0.10)",
                              color: "#031A7F",
                            }}
                          />
                        )}
                      </Box>

                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        {grupo.modulares.map((modular) => (
                          <Box
                            key={`${grupo.grupo_id}-${modular.institucion_id}`}
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: { xs: "flex-start", sm: "center" },
                              gap: 1.25,
                              flexDirection: { xs: "column", sm: "row" },
                              p: 1.25,
                              borderRadius: 1.5,
                              backgroundColor: modular.activo ? "rgba(255,255,255,0.92)" : "#F8FAFC",
                              border: modular.activo
                                ? "1px solid rgba(3,26,127,0.12)"
                                : "1px solid rgba(15,23,42,0.06)",
                            }}
                          >
                            <Box>
                              <Typography
                                sx={{
                                  fontFamily: "Montserrat-SemiBold",
                                  fontSize: "0.88rem",
                                  color: "#0F172A",
                                }}
                              >
                                {(modular.nivel_modalidad || "Sin nivel")} · {getFriendlyRoleName(modular.rol_nombre)}
                              </Typography>
                              <Typography
                                sx={{
                                  mt: 0.2,
                                  fontFamily: "Montserrat-Regular",
                                  fontSize: "0.8rem",
                                  color: "#64748b",
                                }}
                              >
                                Código modular: {modular.institucion_id}
                              </Typography>
                            </Box>

                            {modular.activo ? (
                              <Chip
                                label="Contexto activo"
                                size="small"
                                sx={{
                                  fontFamily: "Montserrat-Medium",
                                  backgroundColor: "rgba(34,197,94,0.12)",
                                  color: "#15803d",
                                }}
                              />
                            ) : (
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={loading}
                                onClick={() => handleSwitchProfileContext(modular.institucion_id)}
                                sx={{
                                  borderRadius: 2,
                                  textTransform: "none",
                                  fontFamily: "Montserrat-Medium",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {loading ? "Cambiando..." : "Usar este contexto"}
                              </Button>
                            )}
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            </>
          )}

          <Divider />

          <Box>
            <Typography
              sx={{
                fontFamily: "Montserrat-Bold",
                fontSize: "1rem",
                color: "#031A7F",
                mb: 1,
              }}
            >
              Seguridad
            </Typography>

            <Typography
              sx={{
                fontFamily: "Montserrat-Regular",
                fontSize: "0.88rem",
                color: "#64748b",
                mb: 2,
              }}
            >
              Gestiona tu acceso de forma segura. Si deseas actualizar tu contraseña, usa la opción de cambio y valida primero tu contraseña actual.
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1.5 }}>
              <Button
                variant="outlined"
                onClick={openPasswordChangeModal}
                startIcon={<LockResetOutlinedIcon />}
                sx={{
                  borderRadius: 2,
                  textTransform: "none",
                  fontFamily: "Montserrat-Medium",
                  px: 3,
                  py: 1,
                  borderColor: "rgba(3,26,127,0.25)",
                  color: "#031A7F",
                }}
              >
                Cambiar contraseña
              </Button>
            </Box>

            {loading && (
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1.5 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <CircularProgress size={16} />
                  <Typography
                    sx={{
                      fontFamily: "Montserrat-Regular",
                      fontSize: "0.82rem",
                      color: "#64748b",
                    }}
                  >
                    Actualizando contexto...
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openPasswordModal}
        onClose={closePasswordModal}
        maxWidth="sm"
        fullWidth
      >
        <Box
          sx={{
            backgroundColor: "#031A7F",
            color: "#ffffff",
            px: 3,
            py: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Box>
            <Typography
              sx={{
                fontFamily: "Montserrat-Bold",
                fontSize: "1.05rem",
                letterSpacing: "0.04em",
              }}
            >
              Cambiar contraseña
            </Typography>
            <Typography
              sx={{
                mt: 0.4,
                fontFamily: "Montserrat-Regular",
                fontSize: "0.82rem",
                opacity: 0.9,
              }}
            >
              Valida tu contraseña actual antes de registrar una nueva.
            </Typography>
          </Box>

          <IconButton
            onClick={closePasswordModal}
            sx={{ color: "#ffffff" }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <DialogContent
          sx={{
            px: 3,
            py: 3,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Typography
            sx={{
              fontFamily: "Montserrat-Regular",
              fontSize: "0.88rem",
              color: "#64748b",
            }}
          >
            Primero valida tu contraseña actual. Luego registra una nueva contraseña con al menos 8 caracteres, una mayúscula, una minúscula y un número.
          </Typography>

          <TextField
            fullWidth
            type={showPasswords.current_password ? "text" : "password"}
            label="Contraseña actual"
            name="current_password"
            value={passwordForm.current_password}
            onChange={handlePasswordFieldChange}
            autoComplete="current-password"
            InputProps={{
              endAdornment: passwordForm.current_password ? (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    onClick={() => togglePasswordVisibility("current_password")}
                  >
                    {showPasswords.current_password ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
                  </IconButton>
                </InputAdornment>
              ) : null,
            }}
            sx={{
              "& input::-ms-reveal, & input::-ms-clear": {
                display: "none",
              },
            }}
          />

          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="outlined"
              onClick={handleValidateCurrentPassword}
              disabled={validatingCurrentPassword || !passwordForm.current_password.trim()}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                fontFamily: "Montserrat-Medium",
              }}
            >
              {currentPasswordValidated
                ? "Contraseña actual validada"
                : (validatingCurrentPassword ? "Validando..." : "Validar contraseña actual")}
            </Button>
          </Box>

          <TextField
            fullWidth
            type={showPasswords.new_password ? "text" : "password"}
            label="Nueva contraseña"
            name="new_password"
            value={passwordForm.new_password}
            onChange={handlePasswordFieldChange}
            autoComplete="new-password"
            disabled={!currentPasswordValidated}
            InputProps={{
              endAdornment: passwordForm.new_password ? (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    onClick={() => togglePasswordVisibility("new_password")}
                  >
                    {showPasswords.new_password ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
                  </IconButton>
                </InputAdornment>
              ) : null,
            }}
            sx={{
              "& input::-ms-reveal, & input::-ms-clear": {
                display: "none",
              },
            }}
          />

          <TextField
            fullWidth
            type={showPasswords.confirm_password ? "text" : "password"}
            label="Confirmar nueva contraseña"
            name="confirm_password"
            value={passwordForm.confirm_password}
            onChange={handlePasswordFieldChange}
            autoComplete="new-password"
            disabled={!currentPasswordValidated}
            InputProps={{
              endAdornment: passwordForm.confirm_password ? (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    onClick={() => togglePasswordVisibility("confirm_password")}
                  >
                    {showPasswords.confirm_password ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
                  </IconButton>
                </InputAdornment>
              ) : null,
            }}
            sx={{
              "& input::-ms-reveal, & input::-ms-clear": {
                display: "none",
              },
            }}
          />

          {passwordFeedback.message && (
            <MuiAlert
              severity={passwordFeedback.type === "success" ? "success" : "error"}
              variant="outlined"
            >
              {passwordFeedback.message}
            </MuiAlert>
          )}

          <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1.5, pt: 1 }}>
            <Button
              variant="outlined"
              onClick={closePasswordModal}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                fontFamily: "Montserrat-Medium",
                px: 3,
              }}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              onClick={handleChangePassword}
              disabled={changingPassword || !currentPasswordValidated}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                fontFamily: "Montserrat-Medium",
                px: 3,
                py: 1,
                backgroundColor: "#031A7F",
              }}
            >
              {changingPassword ? "Actualizando..." : "Actualizar contraseña"}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>


    </>
  );
};

export default NavBar;
